import { useState } from "react";
import { getToken } from "../lib/api";

const BASE = import.meta.env.VITE_API_URL ?? "";

const REPORTS = [
  { key: "participants", label: "Participant list", desc: "All participants with NDIS numbers and status" },
  { key: "timesheets", label: "Timesheet report", desc: "Worked entries by worker and participant", dated: true },
  { key: "invoices", label: "Detailed invoicing", desc: "Every invoice line: support item, band, quantity, amount" },
  { key: "expiring-documents", label: "Expiring documents", desc: "Documents expired or expiring within 30 days" },
  { key: "incidents", label: "Incident register", desc: "Full register incl. NDIS-reportable flags (audit evidence)" },
  { key: "complaints", label: "Complaints register", desc: "References, categories, status history (audit evidence)" },
  { key: "employee-directory", label: "Employee directory", desc: "All staff with role and contact (FR-WFC-06)" },
  { key: "worker-compliance", label: "Worker compliance status", desc: "Per-worker overall status and item counts" },
  { key: "expiring-worker-documents", label: "Expiring worker documents", desc: "Worker documents expired or expiring soon" },
];

export default function Reports() {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function download(key: string, dated?: boolean) {
    setError(null);
    const params = dated && from && to ? `?from=${from}&to=${to}` : "";
    const res = await fetch(`${BASE}/v1/reports/${key}.csv${params}`, {
      headers: { authorization: `Bearer ${getToken()}` },
    });
    if (!res.ok) { setError(`Not available for your role (${res.status})`); return; }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${key}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-ink">Reports</h1>
        <p className="text-sm text-mut">CSV exports — PDF packs and the full SRS report set land in Phase 2.</p>
      </div>
      <div className="flex items-end gap-3">
        <label className="block"><span className="label">From (timesheets)</span>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)}
            className="input block w-auto" /></label>
        <label className="block"><span className="label">To</span>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)}
            className="input block w-auto" /></label>
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      <div className="grid gap-3 sm:grid-cols-2">
        {REPORTS.map((r) => (
          <div key={r.key} className="card p-5 flex items-center justify-between gap-4">
            <div>
              <p className="text-sm font-medium text-ink">{r.label}</p>
              <p className="text-xs text-mut">{r.desc}</p>
            </div>
            <button onClick={() => download(r.key, r.dated)}
              className="shrink-0 btn-secondary px-3 py-1.5">
              CSV ↓
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
